/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faVideoPlus} from '@fortawesome/pro-duotone-svg-icons';

const VideoMentoringIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faVideoPlus} {...props} />
);

export default VideoMentoringIcon;
